import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_aureate-preview/artifacts/h6n4fhlc_Only%20Logo.png';

const HeroSection = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="top" data-testid="hero-section" style={{ padding: 0 }}>
      {/* Wireframe 3D scene */}
      <div className="scene" aria-hidden="true">
        {/* Cube - left */}
        <div className="obj" style={{ left: '8%', top: '25%', width: 120, height: 120 }}>
          <div className="spin-xy">
            <div className="cube" style={{ '--h': '60px', '--o': '.35' }}>
              <i /><i /><i /><i /><i /><i />
            </div>
          </div>
        </div>
        {/* Small cube - right */}
        <div className="obj hide-sm" style={{ left: '85%', top: '60%', width: 60, height: 60, animationDelay: '-3s' }}>
          <div className="spin-xy" style={{ animationDuration: '22s' }}>
            <div className="cube" style={{ '--h': '30px', '--o': '.28' }}>
              <i /><i /><i /><i /><i /><i />
            </div>
          </div>
        </div>
        {/* Cone - top right */}
        <div className="obj" style={{ left: '78%', top: '15%', width: 80, height: 96, opacity: .38, animationDelay: '-2s' }}>
          <div className="spin-y">
            <svg viewBox="0 0 100 120">
              <polygon points="50,10 10,110 90,110" strokeWidth="1" />
              <line x1="50" y1="10" x2="50" y2="110" strokeWidth=".5" strokeOpacity=".5" />
              <ellipse cx="50" cy="110" rx="40" ry="10" strokeWidth="1" />
            </svg>
          </div>
        </div>
        {/* Small cone - bottom left */}
        <div className="obj hide-sm" style={{ left: '15%', top: '70%', width: 50, height: 60, opacity: .25, animationDelay: '-5s' }}>
          <div className="spin-y" style={{ animationDuration: '18s' }}>
            <svg viewBox="0 0 100 120">
              <polygon points="50,10 10,110 90,110" strokeWidth="1" />
              <line x1="50" y1="10" x2="50" y2="110" strokeWidth=".5" strokeOpacity=".5" />
              <ellipse cx="50" cy="110" rx="40" ry="10" strokeWidth="1" />
            </svg>
          </div>
        </div>
        {/* Orbit sphere - left */}
        <div className="obj" style={{ left: '5%', top: '50%', width: 100, height: 100, opacity: .3, animationDelay: '-4s' }}>
          <div className="spin-xz">
            <svg viewBox="0 0 100 100">
              <ellipse cx="50" cy="50" rx="45" ry="20" strokeWidth="1" />
              <ellipse cx="50" cy="50" rx="30" ry="12" strokeWidth=".5" />
              <ellipse cx="50" cy="50" rx="8" ry="20" strokeWidth=".5" />
              <ellipse cx="50" cy="50" rx="8" ry="20" strokeWidth=".5" transform="rotate(45 50 50)" />
              <ellipse cx="50" cy="50" rx="8" ry="20" strokeWidth=".5" transform="rotate(90 50 50)" />
              <ellipse cx="50" cy="50" rx="8" ry="20" strokeWidth=".5" transform="rotate(135 50 50)" />
            </svg>
          </div>
        </div>
        {/* Small orbit - far right */}
        <div className="obj hide-sm" style={{ left: '90%', top: '35%', width: 70, height: 70, opacity: .25, animationDelay: '-6s' }}>
          <div className="spin-xz" style={{ animationDuration: '34s' }}>
            <svg viewBox="0 0 100 100">
              <ellipse cx="50" cy="50" rx="45" ry="20" strokeWidth="1" />
              <ellipse cx="50" cy="50" rx="30" ry="12" strokeWidth=".5" />
              <ellipse cx="50" cy="50" rx="8" ry="20" strokeWidth=".5" />
              <ellipse cx="50" cy="50" rx="8" ry="20" strokeWidth=".5" transform="rotate(45 50 50)" />
              <ellipse cx="50" cy="50" rx="8" ry="20" strokeWidth=".5" transform="rotate(90 50 50)" />
              <ellipse cx="50" cy="50" rx="8" ry="20" strokeWidth=".5" transform="rotate(135 50 50)" />
            </svg>
          </div>
        </div>
        {/* Diamond - bottom right */}
        <div className="obj" style={{ left: '82%', top: '75%', width: 90, height: 90, opacity: .32, animationDelay: '-1s' }}>
          <div className="spin-xy" style={{ animationDuration: '36s' }}>
            <svg viewBox="0 0 100 100">
              <polygon points="50,5 95,50 50,95 5,50" strokeWidth="1" />
              <polygon points="50,20 80,50 50,80 20,50" strokeWidth=".5" />
              <line x1="50" y1="5" x2="50" y2="95" strokeWidth=".5" />
              <line x1="5" y1="50" x2="95" y2="50" strokeWidth=".5" />
            </svg>
          </div>
        </div>
        {/* Small diamond - top left */}
        <div className="obj hide-sm" style={{ left: '20%', top: '12%', width: 55, height: 55, opacity: .25, animationDelay: '-7s' }}>
          <div className="spin-xy" style={{ animationDuration: '26s' }}>
            <svg viewBox="0 0 100 100">
              <polygon points="50,5 95,50 50,95 5,50" strokeWidth="1" />
              <polygon points="50,20 80,50 50,80 20,50" strokeWidth=".5" />
              <line x1="50" y1="5" x2="50" y2="95" strokeWidth=".5" />
              <line x1="5" y1="50" x2="95" y2="50" strokeWidth=".5" />
            </svg>
          </div>
        </div>
        {/* Hexagon - far right */}
        <div className="obj hide-sm" style={{ left: '92%', top: '50%', width: 75, height: 75, opacity: .28, animationDelay: '-2.5s' }}>
          <div className="spin-y" style={{ animationDuration: '30s', animationDirection: 'reverse' }}>
            <svg viewBox="0 0 100 100">
              <polygon points="50,5 85,25 85,75 50,95 15,75 15,25" strokeWidth="1" />
              <polygon points="50,20 70,35 70,65 50,80 30,65 30,35" strokeWidth=".5" />
              <line x1="50" y1="5" x2="50" y2="20" strokeWidth=".5" />
              <line x1="85" y1="25" x2="70" y2="35" strokeWidth=".5" />
              <line x1="85" y1="75" x2="70" y2="65" strokeWidth=".5" />
              <line x1="50" y1="95" x2="50" y2="80" strokeWidth=".5" />
              <line x1="15" y1="75" x2="30" y2="65" strokeWidth=".5" />
              <line x1="15" y1="25" x2="30" y2="35" strokeWidth=".5" />
            </svg>
          </div>
        </div>
        {/* Gold dots */}
        {[
          { left: '22.9%', top: '83.6%', w: 3.5, o: 0.27, d: '0s' },
          { left: '42.7%', top: '92%', w: 4.7, o: 0.23, d: '-2s' },
          { left: '19.7%', top: '27.2%', w: 4.3, o: 0.13, d: '-4s' },
          { left: '19%', top: '55.8%', w: 5.5, o: 0.32, d: '-6s' },
          { left: '81%', top: '82.4%', w: 3.3, o: 0.24, d: '-8s' },
          { left: '82.9%', top: '88.4%', w: 3.7, o: 0.26, d: '-1s' },
          { left: '62.4%', top: '91%', w: 4.9, o: 0.26, d: '-3s' },
          { left: '20.6%', top: '51.6%', w: 2.2, o: 0.12, d: '-5s' },
          { left: '71.8%', top: '60.8%', w: 5.7, o: 0.13, d: '-7s' },
          { left: '9.3%', top: '25.3%', w: 2.4, o: 0.2, d: '-9s' },
          { left: '63%', top: '67.7%', w: 3, o: 0.36, d: '-10s' },
          { left: '89.1%', top: '73.1%', w: 4, o: 0.28, d: '-11s' },
          { left: '24.3%', top: '12.3%', w: 5.9, o: 0.24, d: '-2.5s' },
          { left: '54.1%', top: '36.3%', w: 3.1, o: 0.22, d: '-4.5s' },
          { left: '56.6%', top: '88.5%', w: 3.3, o: 0.23, d: '-6.5s' },
        ].map((dot, i) => (
          <span key={i} className="dot" style={{ left: dot.left, top: dot.top, width: dot.w, height: dot.w, opacity: dot.o, animationDelay: dot.d }} />
        ))}
        {/* Horizontal lines */}
        <span className="hl" style={{ top: '25%' }} />
        <span className="hl" style={{ top: '75%' }} />
        <div className="fade" />
      </div>

      {/* Hero content */}
      <div className="wrap">
        {/* Emblem */}
        <a className="emblem-link rise" href="#top" aria-label="Aureate Residences home" onClick={(e) => { e.preventDefault(); scrollTo('#top'); }}>
          <span className="emblem-wrap">
            <span className="halo" />
            <span className="halo h2" />
            <span className="orbit" />
            <img className="emblem" src={LOGO_URL} alt="" />
          </span>
        </a>

        {/* Tagline with bounce */}
        <div className="tag rise" aria-label="Demand first. Property second." data-testid="hero-tagline">
          <span className="grp"><span className="w">Demand</span><span className="w">first.</span></span>
          <span className="grp"><span className="w g">Property</span><span className="w g">second.</span></span>
        </div>

        <span className="eyebrow rise">Strategic accommodation and property operations &middot; United Kingdom</span>

        <h1 className="rise" data-testid="hero-headline">
          Accommodation that starts with <em>the requirement.</em>
        </h1>

        <p className="lead rise">
          Aureate Residences provides and runs accommodation for councils, housing providers, care organisations and employers, and manages residential and commercial property for its owners, under one brand.
        </p>

        <div className="ctas rise">
          <a className="btn btn-gold" href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} data-testid="hero-cta-primary">
            I need accommodation &rarr;
          </a>
          <a className="btn btn-line" href="#owners" onClick={(e) => { e.preventDefault(); scrollTo('#owners'); }} data-testid="hero-cta-secondary">
            I have a property
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
